import { Base } from "@studiometa/js-toolkit";
import { domScheduler } from "@studiometa/js-toolkit/utils";
import { setHeaderVisibility, headerIsVisible } from "../store/header.js";
class HeaderSwitcher extends Base {
  /**
   * Config.
   */
  static config = {
    name: "HeaderSwitcher",
    refs: ["show", "hide"]
  };
  async mounted() {
    this.update(await headerIsVisible());
  }
  onShowClick() {
    this.show();
  }
  onHideClick() {
    this.hide();
  }
  async show() {
    await setHeaderVisibility("visible");
    this.update(await headerIsVisible());
    this.$refs.hide.focus();
  }
  async hide() {
    await setHeaderVisibility("hidden");
    this.update(await headerIsVisible());
    this.$refs.show.focus();
  }
  update(isVisible) {
    domScheduler.write(() => {
      this.$refs.hide.classList.toggle("flex", isVisible);
      this.$refs.show.classList.toggle("flex", !isVisible);
      this.$refs.hide.classList.toggle("hidden", !isVisible);
      this.$refs.show.classList.toggle("hidden", isVisible);
    });
  }
}
export {
  HeaderSwitcher as default
};
//# sourceMappingURL=HeaderSwitcher.js.map
